import { getDateMs, getDateTime, getStartOfDay } from '../../lib/dateTime';

/**
 * Time that past since the slot started in millis
 */
export const getElapsedTimeSlotInMillis = (
  currentTime: number,
  slotStartTimestamp: number
) => {
  return currentTime - slotStartTimestamp;
};

/**
 * Time that past since last active in millis
 */
export const getElapsedTimeSinceLastActiveInMillis = (
  currentTime: number,
  lastActiveTimestamp: number
) => {
  return currentTime - lastActiveTimestamp;
};

/**
 * Time that past since last active in millis until midnight
 *
 * @param timezone - The timezone to use for calculating midnight (account timezone)
 */
export const getElapsedTimeSinceLastActiveUntilMidnight = (
  currentTime: number,
  lastActiveTimestamp: number,
  timezone?: string
) => {
  return (
    getDateMs(getStartOfDay(getDateTime(currentTime, timezone))) -
    lastActiveTimestamp
  );
};

/**
 * Time that past since slot started in millis until midnight
 *
 * @param timezone - The timezone to use for calculating midnight (account timezone)
 */
export const getElapsedTimeSinceSlotStartUntilMidnight = (
  currentTime: number,
  slotStartTimestamp: number,
  timezone?: string
) => {
  return (
    getDateMs(getStartOfDay(getDateTime(currentTime, timezone))) -
    slotStartTimestamp
  );
};
